export enum MutationTypes {
    SET_TOKEN = 'auth-module/set_token',
    CLEAR_TOKEN = 'auth-module/clear_token',
    SET_ME = 'auth-module/set_user',
    CLEAR_ME = 'auth-module/clear_user',
}
